import { useForm } from "@formspree/react";

export default function Newsletter() {
  const [state, handleSubmit] = useForm("mandyayr"); // same Formspree id you used in Hero

  return (
    <main className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold text-[#0A2540]">Newsletter</h1>
      <p className="mt-2 text-slate-700">
        Short, useful updates on active investigations, eligibility changes, and settlement news.
      </p>

      <section className="mt-6 rounded-2xl border border-[#EADDC2] bg-[#FBF9F4] p-6">
        <h2 className="text-xl font-bold text-[#0A2540]">What you’ll get</h2>
        <ul className="mt-2 list-disc pl-6 text-slate-700 space-y-1">
          <li>Active investigations snapshot</li>
          <li>Eligibility criteria updates</li>
          <li>Deadlines &amp; settlement news</li>
        </ul>

        {state.succeeded ? (
          <div className="mt-6 rounded-lg bg-green-600/10 text-green-800 px-4 py-3">
            Thanks! You’re subscribed.
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="mt-6 grid gap-3 sm:grid-cols-3">
            <input
              className="rounded-lg border border-slate-300 px-3 py-2 outline-none focus:ring-2 focus:ring-[#C89B3C]"
              name="firstName"
              placeholder="Enter your first name *"
              required
            />
            <input
              className="rounded-lg border border-slate-300 px-3 py-2 outline-none focus:ring-2 focus:ring-[#C89B3C]"
              name="email"
              type="email"
              placeholder="Enter your email address *"
              required
            />
            <button
              type="submit"
              disabled={state.submitting}
              className="inline-flex items-center justify-center rounded-full px-5 py-3 font-semibold text-white
                         bg-[#C89B3C] hover:bg-[#B8872D] transition"
            >
              {/* bell icon */}
              <svg className="mr-2" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22ZM20 17h-1V10a7 7 0 1 0-14 0v7H4a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2Zm-3 0H7V10a5 5 0 1 1 10 0v7Z" />
              </svg>
              Subscribe
            </button>
            <input type="hidden" name="formType" value="newsletter" />
          </form>
        )}
      </section>

      <section className="mt-10">
        <h2 className="text-xl font-bold text-[#0A2540]">Recent updates</h2>
        <ul className="mt-3 space-y-2 text-slate-700">
          <li>• April 2025 — Hair Relaxer eligibility clarifications published.</li>
          <li>• March 2025 — Paraquat MDL schedule note; discovery status.</li>
          <li>• March 2025 — RoundUp: highlights from recent filings.</li>
        </ul>
      </section>
    </main>
  );
}
